import styled from 'styled-components';

export const NavbarContainer = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 63px;
  background-color: rgba(26, 26, 26, 0.8);
  color: #fff;
  max-width: 1369px;
  width: 100%;
  margin: 0 auto;
  position: sticky;
  top: 0;
  z-index: 1000;

  @media (max-width: 768px) {
    flex-direction: row;
    align-items: center;
    padding-left: 20px;
    height: auto;
    padding-top: 10px;
  }
`;

export const Logo = styled.div`
  img {
    height: 40px;
  }
`;

export const Menu = styled.ul`
  list-style: none;
  display: flex;
  gap: 20px;
  margin: 0;
  padding: 0;

  li a {
    color: #f16024;
    text-decoration: none;
    font-size: 16px;
    font-weight: 300;
    transition: color 0.3s ease;
    padding: 6px 8px;

    &.active {
      background-color: #252525;
      border-radius: 2px;
      color: #c3c3c3;
    }

    &:hover {
      color: #c3c3c3;
      border-bottom: 2px solid #f16024;
    }
  }

  &.desktop-menu {
    @media (max-width: 768px) {
      display: none;
    }
  }

  &.mobile-menu {
    flex-direction: column;
    align-items: start;
    gap: 10px;
    padding: 10px 0;

    li a {
      color: #f16024; /* Itens normais continuam laranja */

      &.active {
        color: #fff; /* Ativo fica branco */
        background-color: transparent; /* Sem fundo no mobile */
      }
    }
  }
`;

export const HamburgerIcon = styled.div`
  display: none;
  font-size: 24px;
  cursor: pointer;
  color: #f16024;

  @media (max-width: 768px) {
    display: block;
    padding: 0 40px;
    position: relative;
  }
`;

export const ModalContent = styled.div`
  position: absolute;
  top: 50px;
  right: 40px;
  background-color: #1a1a1a;
  opacity: 0.9;
  padding: 10px;
  border-radius: 8px;
  width: 150px;
  text-align: center;
  z-index: 1100;

  ul {
    list-style: none;
    padding: 0;
    margin: 0;

    li {
      padding: 8px 0;
    }

    li a {
      color: #f16024;

      &.active {
        color: #fff;
        border-bottom: none;
      }

      &:hover {
        color: #f16024;
      }
    }
  }
`;
